import { Component, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";

declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
}
export const ROUTES: RouteInfo[] = [
  {
    path: "/dashboard/3",
    title: "Dashboard",
    icon: "icon-chart-pie-36",
    class: "",
  },
  {
    path: "/notifications",
    title: "Notifications",
    icon: "icon-bell-55",
    class: "",
  },

  {
    path: "/user",
    title: "User Profile",
    icon: "icon-single-02",
    class: "",
  },
  {
    path: "/tables",
    title: "Table List",
    icon: "icon-puzzle-10",
    class: "",
  },
];



@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
})
export class SidebarComponent implements OnInit {
  menuItems: any[];
  siteName = environment.siteName
  selectedstatus: any = "Active";
  isQuizOpen = false;
  isLotteryOpen = false;

  closeResult: string;
  levelHierarchy = [
    // { id: 2, name: 'ALL', icon: "icon-single-02", path: "/dashboard" },
    // { id: 2, name: 'WhiteLabel', icon: "icon-single-02", path: "/dashboard/2" },
    { id: 3, name: 'Admin', icon: "icon-single-02", path: "/dashboard/3" },
    { id: 4, name: 'Sub Admin', icon: "icon-single-02", path: "/dashboard/4" },
    { id: 5, name: 'Super Master', icon: "icon-single-02", path: "/dashboard/5" },
    { id: 6, name: 'Master', icon: "icon-single-02", path: "/dashboard/6" },
    // { id: 7, name: 'Agent', icon: "icon-single-02" , path: "/dashboard/7"},
    { id: 0, name: 'Support Agents', icon: "icon-single-02", path: "/dashboard/0" },
    { id: 11, name: 'Quick Agent', icon: "icon-single-02", path: "/dashboard/11" }
  ]

  levelHierarchyforplay25 = [
    // { id: 2, name: 'ALL', icon: "icon-single-02", path: "/dashboard" },
    // { id: 2, name: 'WhiteLabel', icon: "icon-single-02", path: "/dashboard/2" },
    { id: 2, name: 'Site Owner', icon: "icon-single-02", path: "/dashboard/2" },
    { id: 3, name: 'Admin', icon: "icon-single-02", path: "/dashboard/3" },
    { id: 4, name: 'Sub Admin', icon: "icon-single-02", path: "/dashboard/4" },
    { id: 5, name: 'Super Master', icon: "icon-single-02", path: "/dashboard/5" },
    { id: 6, name: 'Master', icon: "icon-single-02", path: "/dashboard/6" },
    { id: 7, name: 'Night Master ', icon: "icon-single-02", path: "/dashboard/7" },
    { id: 0, name: 'Support Agents', icon: "icon-single-02", path: "/dashboard/0" },
    { id: 11, name: 'Quick Agent', icon: "icon-single-02", path: "/dashboard/11" }
  ]



  levelHierarchyforlcagent = [
    // { id: 2, name: 'ALL', icon: "icon-single-02", path: "/dashboard" },
    // { id: 2, name: 'WhiteLabel', icon: "icon-single-02", path: "/dashboard/2" },
    { id: 2, name: 'Admin', icon: "icon-single-02", path: "/dashboard/2" },
    { id: 3, name: 'Senior sub admin', icon: "icon-single-02", path: "/dashboard/3" },
    { id: 4, name: 'Sub Admin', icon: "icon-single-02", path: "/dashboard/4" },
    { id: 5, name: 'Super Master', icon: "icon-single-02", path: "/dashboard/5" },
    { id: 6, name: 'Master', icon: "icon-single-02", path: "/dashboard/6" },
    // { id: 7, name: 'Agent', icon: "icon-single-02" , path: "/dashboard/7"},
    { id: 0, name: 'Support Agents', icon: "icon-single-02", path: "/dashboard/0" },
    { id: 11, name: 'Quick Agent', icon: "icon-single-02", path: "/dashboard/11" }
  ]
  get FilterlevelHierarchy() {
    if (this.siteName == 'lcagentlist') {
      return this.levelHierarchyforlcagent
    }

    if (this.siteName == 'play25') {
      return this.levelHierarchyforplay25
    }


    else {
      return this.levelHierarchy.filter(item => {
        return !(this.siteName === 'vellkielist' && item.name === 'Quick Agent');
      });
    }

  }

  constructor() { }

  ngOnInit() {
    this.menuItems = ROUTES.filter((menuItem) => menuItem);
  }

  isMobileMenu() {
    if (window.innerWidth > 991) {
      return false;
    }
    return true;
  }

  toggleDropdown(type: string) {
    if (type === 'quiz') {
      this.isQuizOpen = !this.isQuizOpen;
    } else if (type === 'lottery') {
      this.isLotteryOpen = !this.isLotteryOpen;
    }
  }

}
